export const GTM_ID = "GTM-MCJCN2K";

export const pageview = (url) => {
	if (typeof window !== "undefined" && window.dataLayer) {
		window.dataLayer.push({
			event: "pageview",
			page_path: url,
		});
	}
};

export const event = ({ action, category, label, value }) => {
	if (typeof window !== "undefined" && window.dataLayer) {
		window.dataLayer.push({
			event: action,
			event_category: category,
			event_label: label,
			value: value,
		});
	}
};
